// extracted by mini-css-extract-plugin
export var copyright = "footer-module--copyright--n0x-n";
export var copyrightLink = "footer-module--copyrightLink--8DfDP";
export var footer = "footer-module--footer--uKVVB";
export var footerLinkItem = "footer-module--footerLinkItem--h0WbE";
export var footerLinkText = "footer-module--footerLinkText--5WqD3";
export var footerLinks = "footer-module--footerLinks--vCq5E";
export var footerLogo = "footer-module--footerLogo--9Nlfi";
export var logo = "footer-module--logo--Yd3ue";